import { render, staticRenderFns } from "./subject-table.vue?vue&type=template&id=74eedccf&scoped=true&"
import script from "./subject-table.vue?vue&type=script&lang=js&"
export * from "./subject-table.vue?vue&type=script&lang=js&"
import style0 from "./subject-table.vue?vue&type=style&index=0&id=74eedccf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74eedccf",
  null
  
)

export default component.exports